import React from "react"
import CookieBanner from "../cookie-banner/cookie-banner.component"
import ScrollToTopButton from "../scrollToTopButton/scrollToTopButton.component"

// styles
import { Container } from "./control.styles"

const Control = () => (
  <Container>
    <CookieBanner />
    <ScrollToTopButton />
  </Container>
)

export default Control
